import type { ReactNode } from 'react';
import { breakpoints, Column, Columns, Stack } from '@etg/wings';
import { cx } from '@eti/styles';
import type { ChatType } from '../../../../common/chat/models';
import { bulletStyles, textKeyTitleStyles } from '../../../../utils/styleUtils';
import ContactMethods from '../../../../common/components/ContactMethods';

interface TopicsContentWrapperProps {
  leftColumnContent: ReactNode;
  rightColumnContent?: ReactNode;
  chatType?: ChatType;
  shouldShowContactMethods?: boolean;
  snowplowProperty?: string;
}

const TopicsContentWrapper = ({
  leftColumnContent,
  rightColumnContent,
  chatType,
  shouldShowContactMethods = true,
  snowplowProperty,
}: TopicsContentWrapperProps) => (
  <Columns collapseBelow={breakpoints._970} spacing={40}>
    <Column
      className={cx(bulletStyles(), textKeyTitleStyles)}
      width={{ [breakpoints._0]: '4/4', [breakpoints._970]: '2/4' }}
    >
      {leftColumnContent}
    </Column>
    {(rightColumnContent || shouldShowContactMethods) && (
      <Column
        data-testid="subtopic-right-column"
        width={{ [breakpoints._0]: '4/4', [breakpoints._970]: '2/4' }}
      >
        <Stack>
          {rightColumnContent}
          {shouldShowContactMethods && (
            <ContactMethods
              chatType={chatType}
              isCallExpanded
              snowplowProperty={snowplowProperty}
            />
          )}
        </Stack>
      </Column>
    )}
  </Columns>
);

export default TopicsContentWrapper;
